import { dsClass } from '../../../common/constants/dsClasses.js';
import { closeMsg, creditDecisionFailureMsg, t } from '../../../common/i18n';
import { DialogWrapper } from '../../DialogWrapper';

interface CreditCheckFailureModalProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * Modal shown when order submission fails due to credit check (HTTP 402).
 * Displays a generic credit check failure message.
 */
export const CreditCheckFailureModal = ({ isOpen, onClose }: CreditCheckFailureModalProps) => {
  if (!isOpen) {
    return null;
  }

  return (
    <DialogWrapper
      header={t.ZK30('Finalizing the order failed')}
      buttons={[
        {
          text: t.WOYD(closeMsg),
          onClick: onClose,
        },
      ]}
      onCloseDialog={onClose}
      closeable={true}
    >
      <p className={dsClass.PADDING_TOP_4}>{t.WXZC(creditDecisionFailureMsg)}</p>
    </DialogWrapper>
  );
};
